"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextStepFirstAppointment = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const NextStepFirstAppointment = (props) => {
    const { userInformation } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !userInformation?.isAlreadyCannabisPatient && (react_1.default.createElement(organisms_1.TimelineEntry, { small: true, title: "Erstgespr\u00E4ch vereinbaren", infoText: "Vervollst\u00E4ndigen Sie zun\u00E4chst Ihre Angaben" })),
        react_1.default.createElement(organisms_1.TimelineEntry, { title: "Erstgespr\u00E4ch", infoText: "Hierf\u00FCr muss ein Erstgespr\u00E4ch vereinbart worden sein" })));
};
exports.NextStepFirstAppointment = NextStepFirstAppointment;
